import { Spin } from "antd";
import queryString from "query-string";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { apiClient, urlClientInfo } from "../../../api";
import ModalWarning from "../../../components/Ants/Modal/ModalWarning";
import Banner from "../../../components/SlideBanner/Banner";
import {
  CheckUserLogedin,
  getExpiredDate,
  set_cookie
} from "../../../config";
import OtpForm from "./components/OtpForm";
import RegisterForm from "./components/RegisterForm";
import "./components/RegisterForm.scss";
import ModalWarningIsOk from "../../../components/Ants/Modal/ModalWarningIsOk";

function useIsMobile() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // threshold for mobile

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile;
}

export default function Register(props) {
  const recaptchaRef = React.createRef();
  const [state, setState] = useState({
    showPassword: false,
    showConfirmPassword: false,
    showOtpForm: false,
    showOtpErrorMessage: false,
    otpErrorMessage: "",
    OTPref: "",
  });
  const [errorMessage, setErrorMessage] = useState("");
  const [openModalError, setOpenModalError] = useState(false)
  const [model, setModel] = useState({
    contactName: "",
    email: "",
    password: "",
    confirmPassword: "",
    recaptchaToken: null,
    OTPcode: "",
    OTPref: "",
    OTPid: "",
    typeUser: 1,
  });
  const [packageId, setPackageId] = useState("");
  const [clientInfo, setclientInfo] = useState({});
  const [loading, setLoading] = useState(false)

  const history = useHistory()
  const { search } = useLocation();
  const query = new URLSearchParams(search)
  const success = query.get("success");
  const uuid = query.get("uuid");
  const provider = query.get("provider");
  const username = query.get("username");
  const message = query.get("message");
  const pidParam = query.get('pid');
  const typeParam = query.get('type');

  const type = localStorage.getItem('type');
  const pid = localStorage.getItem('pid');

  const [settingJson, setSettingJson] = useState({
    env: {
      title: "Loading...",
      name: "ants",
      imgFolder: "ANTS",
    },
    imgpath: null,
    classBackground: null
  });

  useEffect(() => {
    getClientInfo();
    if (CheckUserLogedin()) {
      history.push("/PackageList");
    }
    if (pid) {
      setPackageId(pid);
    }

    getSettingJson();
  }, []);

  const getSettingJson = () => {
    apiClient.get('api/function/getappsettings')
      .then((response) => {
        const json = response.data;

        setSettingJson({ ...settingJson, imgpath: `../../../../src/img/${json.env.imgFolder}/Logo_Web.png` })

        switch (json.env.name) {
          case "ANTS":
            setSettingJson({ ...settingJson, classBackground: "login-ants-background" })
            break;
          case "ECOM":
            setSettingJson({ ...settingJson, classBackground: "login-ants-background" })
            break;
          case "YING":
            setSettingJson({ ...settingJson, classBackground: "login-ants3-background" })
            break;
          case "SMS Up":
            setSettingJson({ ...settingJson, classBackground: "login-ants4-background" })
            break;
          case "Promotech":
            setSettingJson({ ...settingJson, classBackground: "login-promotech-background" })
            break;
          case "True":
            this.setState({ settingJson: { ...this.state.settingJson, classBackground: "login-true-background" } })
            break;
        }

      })
      .catch(error => console.error('Error fetching JSON:', error));
  }

  const getClientInfo = () => {
    urlClientInfo
      .get("", {
        headers: {},
      })
      .then((response) => {
        let req = {
          ipString: response.data.ipString,
          userAgent: response.data.userAgent,
        }
        setclientInfo(req);
      })
      .catch((error) => {
        setclientInfo({
          ipString: "",
          userAgent: "",
        });
      });
  }

  const callGetOTP = async () => {
    setLoading(true)
    setState({
      ...state,
      otpErrorMessage: "",
      showOtpErrorMessage: false,
    });
    if (model.email != "") {
      await apiClient
        .post(
          "api/accountregister/getotp",
          { email: model.email },
          {
            headers: { "Content-type": "application/json; charset=UTF-8" },
          }
        )
        .then((response) => {
          if (response.data.success.message == "200") {
            setState({ ...state, showOtpForm: true });
            setModel({
              ...model,
              OTPref: response.data.referenceCode,
              OTPid: response.data.otpId,
              OTPcode: "",
            });
          } else {
            setErrorMessage(response.data.success.description);
          }
          setLoading(false)
        })
        .catch((error) => {
          setErrorMessage(error.message);
          setLoading(false)
        });
    } else {
      setState({ ...state, showOtpForm: false });
      setLoading(false)
    }
  };

  const callRegisterApi = async () => {
    setLoading(true);
    let req = {
      name: model.contactName,
      email: model.email,
      username: model.email,
      password: model.password,
      repeatpassword: model.confirmPassword,
      typeUser: model.typeUser,
      pid: packageId,
      client: clientInfo
    };

    await apiClient
      .post("api/accountregister/register", req, {
        headers: { "Content-type": "application/json; charset=UTF-8" },
      })
      .then(async (response) => {
        if (response.data.resultCode == "201") {
          await AutoLogin();
        } else {
          setState({ ...state, showOtpForm: false });
          setErrorMessage(response.data.message);
        }
        setLoading(false);
      })
      .catch((error) => {
        setState({
          ...state,
          showOtpErrorMessage: true,
          otpErrorMessage: error.message,
        });
        setLoading(false);
      });
  };

  const AutoLogin = async () => {
    setLoading(true);
    let req = JSON.stringify({
      "username": model.email,
      "password": model.password,
      "expireMinutes": "60",
      "ip": clientInfo.ipString,
      "device": clientInfo.userAgent,
    });

    await apiClient.post('api/Token', req
      , { headers: { 'Content-type': 'application/json; charset=UTF-8' } })
      .then(data => {
        var json = data;
        let Token = "__AntiXsrfUerkey=" + encodeURIComponent(json.data);
        let ExpiredDate = getExpiredDate(Token).toGMTString();
        let SendToken = Token + ";expires=" + ExpiredDate + ";path=/";
        set_cookie(SendToken);

        if (pid) {
          history.push(`/RequestTaxInfo?type=${type}&pid=${pid}`);
        } else {
          history.push("/dashboard");
        }
        setLoading(false);
      })
      .catch(error => {
        setErrorMessage(`Auto login failed: ${error.message}`);
        setLoading(false);
      });
  }

  const autoSocialLogin = async (uuid, provider, username, pidParam, typeParam) => {

    const req = {
      "uuid": uuid,
      "provider": provider,
      "username": username,
      "expireMinutes": "60",
      "ip": clientInfo.ipString,
      "device": clientInfo.userAgent
    }
    try {
      await apiClient.post('api/social-token', req
        , { headers: { 'Content-type': 'application/json; charset=UTF-8' } })
        .then(data => {

          var json = data;
          let Token = "__AntiXsrfUerkey=" + encodeURIComponent(json.data);
          let ExpiredDate = getExpiredDate(Token).toGMTString();
          let SendToken = Token + ";expires=" + ExpiredDate + ";path=/";
          set_cookie(SendToken);

          if (pidParam !== "null") {
            history.push(`/RequestTaxInfo?type=${typeParam}&pid=${pidParam}`);
          } else {
            history.push("/dashboard");
          }
          setLoading(false);
        })
        .catch(error => {
          setErrorMessage(`Auto login failed: ${error.message}`);
          setLoading(false);
        });
    }
    catch (err) {
      setErrorMessage("Recaptcha validation error: " + err.message);
    }

  }

  const warningModal = (value, message, messageSuccess) => {
    setOpenModalError(value)
    setErrorMessage(message)
  }

  useEffect(() => {
    if (success !== null) {
      if (uuid && provider && username) {
        autoSocialLogin(uuid, provider, username, encodeURIComponent(pidParam), typeParam);
      } else {
        setOpenModalError(true)
      }
    } else {
      if (window.location.hash === '#_=_') {
        window.history.replaceState(null, '', window.location.pathname + window.location.search);
      }
    }

  }, [success, uuid, message, provider, username, pidParam, typeParam]);

  const handleHaveToRegister = () => {
    setOpenModalError(false)
    if (window.location.search) {
      const newUrl = window.location.origin + window.location.pathname;
      window.history.replaceState({}, document.title, newUrl);
    }
  }

  return (
    <Spin spinning={loading} >
      <div className="register-card">
        {!useIsMobile() ? <Banner page={state.showOtpForm ? "otp" : "register"} /> : null}
        {!state.showOtpForm ? (
          <RegisterForm
            history={history}
            recaptchaRef={recaptchaRef}
            errorMessage={errorMessage}
            setErrorMessage={setErrorMessage}
            state={state}
            setState={setState}
            model={model}
            setModel={setModel}
            callGetOTP={callGetOTP}
            loading={loading}
            setLoading={setLoading}
            pid={pid}
            type={type}
          />
        ) : (
          <OtpForm
            callRegisterApi={callRegisterApi}
            state={state}
            setState={setState}
            model={model}
            setModel={setModel}
            callGetOTP={callGetOTP}
            loading={loading}
          />
        )}
        <ModalWarningIsOk
          loading={loading}
          warningModalVisible={openModalError}
          warningModal={warningModal}
          message={message}
          messageSuccess={""}
          closemodal={() => handleHaveToRegister()}
        />
      </div>
    </Spin>
  );
}
